module.exports = __webpack_public_path__ + "img/rightTxt2.901e93ef.png";